import { EnumBuilder, type ZodSimplify } from '@mntn-dev/utility-types'

/**
 * BidSurveyTypeSchema
 */
export const [BidSurveyTypes, BidSurveyTypeSchema, BidSurveyTypeEnum] =
  EnumBuilder('bid-accepted-by-brand', 'bid-rejected-by-brand')

export type BidSurveyType = ZodSimplify<typeof BidSurveyTypeSchema>

/**
 * LegacyQuickframeSurveyTypeSchema
 */
export const [
  LegacyQuickframeSurveyTypes,
  LegacyQuickframeSurveyTypeSchema,
  LegacyQuickframeSurveyTypeEnum,
] = EnumBuilder('legacy-quickframe-maker-rating')

export type LegacyQuickframeSurveyType = ZodSimplify<
  typeof LegacyQuickframeSurveyTypeSchema
>

/**
 * OfferSurveyTypeSchema
 */
export const [OfferSurveyTypes, OfferSurveyTypeSchema, OfferSurveyTypeEnum] =
  EnumBuilder('offer-accepted', 'offer-declined')

export type OfferSurveyType = ZodSimplify<typeof OfferSurveyTypeSchema>

/**
 * ProjectSurveyTypeSchema
 */
export const [
  ProjectSurveyTypes,
  ProjectSurveyTypeSchema,
  ProjectSurveyTypeEnum,
] = EnumBuilder(
  'project-completed-brand-reviews-maker',
  'project-completed-maker-reviews-brand'
)

export type ProjectSurveyType = ZodSimplify<typeof ProjectSurveyTypeSchema>

/**
 * SurveyTypeSchema
 */
export const [SurveyTypes, SurveyTypeSchema, SurveyTypeEnum] = EnumBuilder(
  ...BidSurveyTypes,
  ...LegacyQuickframeSurveyTypes,
  ...OfferSurveyTypes,
  ...ProjectSurveyTypes
)

export type SurveyType = ZodSimplify<typeof SurveyTypeSchema>
